/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    SgSptMedicalConditionsHeader: {
        id: 'qnb.spt.SgSptMedicalConditionsModal.Header.Msg',
        defaultMessage: 'Travellers Details'
    },
    FirstDisclaimerText: {
        id: 'qnb.spt.SgSptMedicalConditionsModal.FirstDisclaimerText',
        defaultMessage: 'We will cover you for the conditions declared below if you are taken ill whilst abroad, or are involved in an accident.'
    },
    SecondDisclaimerTextSmall: {
        id: 'qnb.spt.SgSptMedicalConditionsModal.SecondDisclaimerTextSmall',
        defaultMessage: 'You have declared that you are on a waiting list for in-patient or out-patient treatment.'
    },
    SecondDisclaimerTextExpanded: {
        id: 'qnb.spt.SgSptMedicalConditionsModal.SecondDisclaimerTextExpanded',
        defaultMessage: ' We are able to offer cover for claims arising in respect of the medical condition for which you are on a waiting list, while abroad, providing you are not travelling against your UK doctor’s advice. Where a claim is made under the Cancellation or Abandonment sections of the Policy as a direct result of the medical condition for which you are on a waiting list, you will not have cover under these sections.'
    },
});
